import { render, staticRenderFns } from "./tyyKnowledgeSettingLists.vue?vue&type=template&id=64dbeb8b&"
import script from "./tyyKnowledgeSettingLists.vue?vue&type=script&lang=js&"
export * from "./tyyKnowledgeSettingLists.vue?vue&type=script&lang=js&"
import style0 from "./tyyKnowledgeSettingLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports